import { render } from "./InitiateMoneyRequest.vue?vue&type=template&id=1f365368"
import script from "./InitiateMoneyRequest.vue?vue&type=script&lang=js"
export * from "./InitiateMoneyRequest.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__